import { useMemo } from 'react';
import { useLocation } from 'react-router-dom';

export function useRouteQuery(param: string) {
  const { search } = useLocation();

  return useMemo(() => new URLSearchParams(search).get(param), [param, search]);
}
